import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { ContributionFlowData } from '../../pages/admin-welcome/contribution-flow/contribution-flow-data.service';

@Injectable()
export class NetworkMemberService {
  private readonly resourceUrl = '/network-member';

  constructor(private apiService: ApiService) {}

  public submitContributionConfig(configData: ContributionFlowData | FormData): Observable<any> {
    return this.apiService.post(this.resourceUrl + '/contri-config', configData);
  }

  public getContributionConfig(uuid: string): Observable<any> {
    return this.apiService.get(this.resourceUrl + `/contri-config/${uuid}`);
  }

  public updateContributionConfig(uuid: string, configData: ContributionFlowData | FormData): Observable<any> {
    return this.apiService.put(this.resourceUrl + `/contri-config/${uuid}`, configData);
  }
}
